<ng-container *ngIf="icon">
  <!------------------HOSTED------------------>
  <div
    *ngIf="point"
    [ngClass]="{
      'save-icon-small': size === 'small',
      'save-icon-medium': size === 'medium',
      'save-icon-large': size === 'large',
      'save-icon-wrapper-right': right
    }"
    class="save-icon-wrapper save-icon-private"
  >
    <div *ngIf="!addedToTrip" (click)="addToTrip()" class="icon-save">
      <curbnturf-site-svgs type="rvtrip" color="#fff"></curbnturf-site-svgs>
      <ion-icon name="add-circle-outline"></ion-icon>
    </div>
    <div *ngIf="addedToTrip" (click)="removeFromTrip()" class="icon-save">
      <curbnturf-site-svgs type="rvtrip" color="#fff"></curbnturf-site-svgs>
      <ion-icon name="remove-circle-outline"></ion-icon>
    </div>
    <div *ngIf="user?.id && !favorited" (click)="favorite()" class="icon-save">
      <curbnturf-misc-svg icon="save" color="#fff"></curbnturf-misc-svg>
    </div>
    <div *ngIf="!user?.id" (click)="openModalSave()" class="icon-save">
      <curbnturf-misc-svg icon="save" color="#fff"></curbnturf-misc-svg>
    </div>
    <div *ngIf="user?.id && favorited" (click)="unfavorite()" class="icon-save">
      <curbnturf-misc-svg icon="saved" color="#fff"></curbnturf-misc-svg>
    </div>
  </div>
  <!---------------BOONDOCK & POI------------------>
  <div
    *ngIf="boondockPoint || poi"
    [ngClass]="{
      'save-icon-small': size === 'small',
      'save-icon-medium': size === 'medium',
      'save-icon-large': size === 'large',
      'save-icon-wrapper-right': right
    }"
    class="save-icon-wrapper"
  >
    <div *ngIf="user?.id && !favorited" (click)="favorite()" class="icon-save">
      <curbnturf-misc-svg icon="save" color="#fff"></curbnturf-misc-svg>
    </div>
    <div *ngIf="!user?.id" (click)="openModalSave()" class="icon-save">
      <curbnturf-misc-svg icon="save" color="#fff"></curbnturf-misc-svg>
    </div>
    <div *ngIf="user?.id && favorited" (click)="unfavorite()" class="icon-save">
      <curbnturf-misc-svg icon="saved" color="#fff"></curbnturf-misc-svg>
    </div>
    <div *ngIf="!user?.id" (click)="openModalRate()" class="icon-rating">
      <curbnturf-misc-svg icon="rate" color="#fff"></curbnturf-misc-svg>
    </div>
    <div *ngIf="user?.id" (click)="rate()" class="icon-rating">
      <curbnturf-misc-svg icon="rate" color="#fff"></curbnturf-misc-svg>
    </div>
    <div *ngIf="poi?.id || boondockPoint?.id" (click)="navigate()" class="icon-direction">
      <curbnturf-misc-svg icon="navigate" color="#fff"></curbnturf-misc-svg>
    </div>
    <div *ngIf="!user?.id" (click)="openModalDonate()" class="icon-donation">
      <curbnturf-misc-svg icon="donate" color="#fff"></curbnturf-misc-svg>
    </div>
    <div *ngIf="user?.id" (click)="donate()" class="icon-donation">
      <curbnturf-misc-svg icon="donate" color="#fff"></curbnturf-misc-svg>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!icon">
  <!------------------HOSTED------------------>
  <div *ngIf="point" [ngClass]="{ 'save-icon-wrapper-right': right }" class="save-wrapper">
    <a *ngIf="!addedToTrip" (click)="addToTrip()" class="cnt-button-secondary w-button" data-cy="add-to-trip">
      Add to Trip
    </a>
    <a
      *ngIf="addedToTrip"
      (click)="removeFromTrip()"
      class="cnt-button-secondary inverted w-button"
      data-cy="remove-from-trip"
    >
      Remove from Trip
    </a>
    <a *ngIf="user?.id && !favorited" (click)="favorite()" class="cnt-button-secondary w-button" data-cy="save-listing">
      Save this property
    </a>
    <a *ngIf="!user?.id" (click)="openModalSave()" class="cnt-button-secondary w-button" data-cy="save-listing">
      Save this property
    </a>
    <a
      *ngIf="user?.id && favorited"
      (click)="unfavorite()"
      class="cnt-button-secondary inverted w-button"
      data-cy="forget-listing"
    >
      Forget this property
    </a>
  </div>
  <!------------------BOONDOCK------------------>
  <div *ngIf="boondockPoint || poi" [ngClass]="{ module: poi, 'save-icon-wrapper-right': right }" class="save-wrapper">
    <a *ngIf="!addedToTrip" (click)="addToTrip()" class="cnt-button-secondary w-button" data-cy="add-to-trip">
      Add To Trip
    </a>
    <a
      *ngIf="addedToTrip"
      (click)="removeFromTrip()"
      class="cnt-button-secondary inverted w-button"
      data-cy="remove-from-trip"
    >
      Remove From Trip
    </a>
    <a *ngIf="user?.id && !favorited" (click)="favorite()" class="cnt-button-secondary w-button" data-cy="save-listing">
      Save this property
    </a>
    <a *ngIf="!user?.id" (click)="openModalSave()" class="cnt-button-secondary w-button" data-cy="save-listing">
      Save this property
    </a>
    <a
      *ngIf="user?.id && favorited"
      (click)="unfavorite()"
      class="cnt-button-secondary inverted w-button"
      data-cy="forget-listing"
    >
      Forget this property
    </a>
    <a *ngIf="!user?.id" (click)="openModalRate()" class="cnt-button-secondary w-button" data-cy="rate-listing">
      Rate this property
    </a>
    <a *ngIf="user?.id" (click)="rate()" class="cnt-button-secondary w-button" data-cy="rate-listing">
      Rate this property
    </a>
    <a *ngIf="!point" (click)="navigate()" class="cnt-button-secondary w-button" data-cy="get-directions">
      Get directions
    </a>
    <a *ngIf="!user?.id" (click)="openModalDonate()" class="cnt-button-secondary w-button" data-cy="donate-btn">
      Donate
    </a>
    <a *ngIf="user?.id" (click)="donate()" class="cnt-button-secondary w-button" data-cy="donate-btn"> Donate </a>
  </div>
</ng-container>
